import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import { testimonials, stats } from "../../mocks/testimonials";
import { Link } from "react-router-dom";

export default function TestimonialsPage() {
  return (
    <main>
      <Navbar />

      {/* Hero */}
      <section className="relative pt-40 pb-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/5a08b0aa5d37242e53fab7214f907cf3.jpg"
            alt="Testimonials"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-zinc-900/70"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <span className="text-amber-400 text-xs font-bold tracking-widest uppercase" style={{ fontFamily: "'Raleway', sans-serif" }}>Customer Reviews</span>
          <h1 className="text-5xl lg:text-6xl font-bold text-white mt-4 mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            What Our Customers Say
          </h1>
          <p className="text-stone-300 text-lg max-w-2xl mx-auto" style={{ fontFamily: "'Raleway', sans-serif" }}>
            Real feedback from real homeowners across Surrey and South London who trusted Ensure Windows with their homes.
          </p>
        </div>
      </section>

      {/* Stats */}
      <section className="bg-amber-600 py-10">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            {stats.map((stat) => (
              <div key={stat.label}>
                <p className="text-white text-3xl font-bold" style={{ fontFamily: "'Cormorant Garamond', serif" }}>{stat.value}</p>
                <p className="text-amber-100 text-sm mt-1" style={{ fontFamily: "'Raleway', sans-serif" }}>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Reviews Grid */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {testimonials.map((t) => (
              <div key={t.id} className="bg-white rounded-lg p-7 border border-stone-100">
                {/* Rating */}
                <div className="flex gap-1 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <div key={i} className="w-4 h-4 flex items-center justify-center">
                      <i className={`${i < t.rating ? "ri-star-fill text-amber-500" : "ri-star-line text-stone-300"} text-sm`}></i>
                    </div>
                  ))}
                </div>
                {/* Product Tag */}
                <span className="inline-block bg-amber-50 text-amber-700 text-xs font-semibold px-2.5 py-1 rounded mb-3" style={{ fontFamily: "'Raleway', sans-serif" }}>
                  {t.product}
                </span>
                {/* Review */}
                <p className="text-zinc-600 text-sm leading-relaxed mb-6 italic" style={{ fontFamily: "'Raleway', sans-serif" }}>
                  &ldquo;{t.text}&rdquo;
                </p>
                {/* Author */}
                <div className="flex items-center gap-3 pt-4 border-t border-stone-100">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-600 rounded-full text-white text-xs font-bold flex-shrink-0">
                    {t.avatar}
                  </div>
                  <div>
                    <p className="text-zinc-800 text-sm font-semibold" style={{ fontFamily: "'Raleway', sans-serif" }}>{t.name}</p>
                    <p className="text-zinc-400 text-xs" style={{ fontFamily: "'Raleway', sans-serif" }}>{t.location} · {t.date}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Write a Review CTA */}
      <section className="py-16 bg-white border-t border-stone-100">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-amber-50 rounded-full mx-auto mb-5">
            <i className="ri-star-smile-line text-amber-600 text-3xl"></i>
          </div>
          <h3 className="text-3xl font-bold text-zinc-900 mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Had Work Done by Ensure Windows?
          </h3>
          <p className="text-zinc-500 text-base mb-8" style={{ fontFamily: "'Raleway', sans-serif" }}>
            We would love to hear from you. Share your experience and help other homeowners make the right choice.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/contact" className="bg-amber-600 hover:bg-amber-700 text-white font-semibold px-7 py-3 rounded-md whitespace-nowrap cursor-pointer transition-colors" style={{ fontFamily: "'Raleway', sans-serif" }}>
              Contact Us
            </Link>
            <Link to="/gallery" className="border-2 border-zinc-800 text-zinc-800 hover:bg-zinc-800 hover:text-white font-semibold px-7 py-3 rounded-md whitespace-nowrap cursor-pointer transition-all" style={{ fontFamily: "'Raleway', sans-serif" }}>
              View Our Work
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
